import React from "react";
import { formatCurrency, formatPercentage } from "utils/number";

function formatValue(value: string | number | undefined, format?: string) {
  if (!format) return value;

  switch (format) {
    case "currency":
      return formatCurrency(value as number | string);
    case "percentage":
      return formatPercentage(value as number | string);
    default:
      return value;
  }
}
import "./Kpi.scss";

interface KpiProps {
  label?: string;
  value?: string | number;
  format?: string;
}

const Kpi = ({ label, value, format }: KpiProps) => {
  return (
    <div className="kpi-container">
      <p className="kpi-label">{label}</p>
      <p className="kpi-value">{formatValue(value, format)}</p>
    </div>
  );
};

export default Kpi;
